// import Kid1 from "../assets/kid1.jpg";
import Kid2 from "../assets/Kid2.jpg";
import Kid3 from "../assets/kids3.jpg";
import Kid4 from "../assets/kids4.jpg";

const HowItWork = () => {
  return (
    <div className="mb-n10 mb-lg-n20 z-index-2">
      <div className="container">
        <div className="text-center mb-17">
          <h3
            className="fs-2hx text-dark mb-5"
            id="who-are-we"
            data-kt-scroll-offset="{default: 100, lg: 150}"
          >
            Who are we?
          </h3>

          <div className="fs-5 text-muted fw-bold">
            We are proudly Non-profit, Non-corporate and non-compromised.
            <br />
            People like you help us keep the displaced and vulnerable
          </div>
        </div>

        <div className="row w-100 gy-10 mb-md-20">
          {/* <div className="col-md-4 px-5">
            <div className="text-center mb-10 mb-md-0">
              <img
                src="assets/media/illustrations/process-2.png"
                className="mh-125px mb-9"
                alt=""
              />

              <div className="d-flex flex-center mb-5">
                <span className="badge badge-circle badge-light-success fw-bolder p-5 me-3 fs-3">
                  1
                </span>

                <div className="fs-5 fs-lg-3 fw-bolder text-dark">
                  Jane Miller
                </div>
              </div>

              <div className="fw-bold fs-6 fs-lg-4 text-muted">
                Save thousands to millions of bucks
                <br />
                by using single tool for different
                <br />
                amazing and great
              </div>
            </div>
          </div> */}
          {/* 
          <div className="col-md-4 px-5">
            <div className="text-center mb-10 mb-md-0">
              <img
                src="assets/media/illustrations/process-3.png"
                className="mh-125px mb-9"
                alt=""
              />

              <div className="d-flex flex-center mb-5">
                <span className="badge badge-circle badge-light-success fw-bolder p-5 me-3 fs-3">
                  2
                </span>

                <div className="fs-5 fs-lg-3 fw-bolder text-dark">
                  Setup Your App
                </div>
              </div>

              <div className="fw-bold fs-6 fs-lg-4 text-muted">
                Save thousands to millions of bucks
                <br />
                by using single tool for different
                <br />
                amazing and great
              </div>
            </div>
          </div> */}

          {/* <div className="col-md-4 px-5">
            <div className="text-center mb-10 mb-md-0">
              <img
                src="assets/media/illustrations/process-4.png"
                className="mh-125px mb-9"
                alt=""
              />

              <div className="d-flex flex-center mb-5">
                <span className="badge badge-circle badge-light-success fw-bolder p-5 me-3 fs-3">
                  3
                </span>

                <div className="fs-5 fs-lg-3 fw-bolder text-dark">
                  Enjoy Nautica App
                </div>
              </div>

              <div className="fw-bold fs-6 fs-lg-4 text-muted">
                Save thousands to millions of bucks
                <br />
                by using single tool for different
                <br />
                amazing and great
              </div>
            </div>
          </div> */}
        </div>

        <div className="tns tns-default">
          <div
            data-tns="true"
            data-tns-loop="true"
            data-tns-swipe-angle="false"
            data-tns-speed="2000"
            data-tns-autoplay="true"
            data-tns-autoplay-timeout="18000"
            data-tns-controls="true"
            data-tns-nav="false"
            data-tns-items="1"
            data-tns-center="false"
            data-tns-dots="false"
            data-tns-prev-button="#kt_team_slider_prev1"
            data-tns-next-button="#kt_team_slider_next1"
          >
            {/* <div className="text-center px-5 pt-5 pt-lg-10 px-lg-10">
              <img src={Kid1} className="card-rounded shadow mw-100" alt="" />
            </div> */}

            <div className="text-center px-5 pt-5 pt-lg-10 px-lg-10">
              <img src={Kid2} className="card-rounded shadow mw-100" alt="" />
            </div>

            <div className="text-center px-5 pt-5 pt-lg-10 px-lg-10">
              <img src={Kid3} className="card-rounded shadow mw-100" alt="" />
            </div>

            <div className="text-center px-5 pt-5 pt-lg-10 px-lg-10">
              <img src={Kid4} className="card-rounded shadow mw-100" alt="" />
            </div>
          </div>

          <button
            className="btn btn-icon btn-active-color-primary"
            id="kt_team_slider_prev1"
          >
            <span className="svg-icon svg-icon-3x">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z"
                    fill="#000000"
                    fillRule="nonzero"
                    transform="translate(12.000003, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-12.000003, -11.999999)"
                  />
                </g>
              </svg>
            </span>
          </button>

          <button
            className="btn btn-icon btn-active-color-primary"
            id="kt_team_slider_next1"
          >
            <span className="svg-icon svg-icon-3x">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z"
                    fill="#000000"
                    fillRule="nonzero"
                    transform="translate(12.000003, 11.999999) rotate(-270.000000) translate(-12.000003, -11.999999)"
                  />
                </g>
              </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowItWork;
